module.exports = __webpack_public_path__ + "files/3cbfdf87f2c3625493e34e0b817b69d2.png";